import {styled} from '@linaria/react';
import {FONT_SIZES} from '../../../constants/typography';
import {baseCss} from './Text';

const Paragraph = styled.p`
  ${baseCss}
`;

export const Paragraph10 = styled(Paragraph)`
  font-size: ${FONT_SIZES.px10};
  line-height: 1.6;
`;

export const Paragraph12 = styled(Paragraph)`
  font-size: ${FONT_SIZES.px12};
  line-height: 1.5;
`;

export const Paragraph14 = styled(Paragraph)`
  font-size: ${FONT_SIZES.px14};
  line-height: calc(9 / 7);
`;

export const Paragraph16 = styled(Paragraph)`
  font-size: ${FONT_SIZES.px16};
  line-height: 1.25;
`;

export const Paragraph18 = styled(Paragraph)`
  font-size: ${FONT_SIZES.px18};
  line-height: calc(13 / 9);
`;

export const Paragraph20 = styled(Paragraph)`
  font-size: ${FONT_SIZES.px20};
  line-height: 1.5;
`;

export const Paragraph24 = styled(Paragraph)`
  font-size: ${FONT_SIZES.px24};
  line-height: 1.5;
`;

export const Paragraph32 = styled(Paragraph)`
  font-size: ${FONT_SIZES.px32};
  line-height: 1.5;
`;
